import { CommonModule } from '@angular/common';
import {
 AfterViewInit,
 Component,
 ElementRef,
 inject,
 Inject,
 QueryList,
 ViewChildren,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Component({
 selector: 'iho-loading-modal',
 standalone: true,
 imports: [CommonModule, MatDialogModule],
 providers: [],
 templateUrl: './loading-modal.component.html',
 styleUrls: ['./loading-modal.component.scss'],
})
export class LoadingModalComponent {
 modaldata: any;
 searchBoxService = inject(SearchBoxService);

 constructor(@Inject(MAT_DIALOG_DATA) data: { data: any }) {
  this.modaldata = data;
 }
}
